import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import { Button, FormControl, IconButton, InputAdornment, InputLabel, OutlinedInput, Stack } from "@mui/material";
import React, { FormEvent, ReactNode } from "react";
import "./Login.css";

import { useGoogleLogin } from "@react-oauth/google";

import Google from "../../static/google.svg";

import { Link } from "react-router-dom";
import { LoginMethod } from "../../enums/enums";

export default function LoginForm(props: {
  children: ReactNode;
  callback: CallableFunction;
  google: CallableFunction;
}) {
  // page interaction specific stuff
  const [open, setOpen] = React.useState(false);
  const handleClickShowPassword = () => setShowPassword((show) => !show);
  const handleMouseDownPassword = (event: React.MouseEvent<HTMLButtonElement>) => event.preventDefault();

  // state for form inputs for login
  const [username, setUsername] = React.useState("");
  const [password, setPassword] = React.useState("");
  const [showPassword, setShowPassword] = React.useState(false);

  const handleSubmit = (e: FormEvent) => {
    e.preventDefault();
    props.callback({ username, password });
  };

  const login = useGoogleLogin({
    onSuccess: (codeResponse) => {
      props.google(codeResponse, LoginMethod.GOOGLE);
    },
    flow: "auth-code",
  });

  return (
    <Stack component={"form"} sx={{ flexGrow: 1 }} spacing={2} onSubmit={handleSubmit}>
      <FormControl fullWidth={true}>
        <InputLabel htmlFor="outlined-basic">Username</InputLabel>
        <OutlinedInput
          id="outlined-basic"
          placeholder="Username"
          label="Username"
          type="email"
          required
          onChange={(e) => setUsername(e.target.value)}
        />
      </FormControl>
      <FormControl fullWidth={true}>
        <InputLabel htmlFor="outlined-adornment-password">Password</InputLabel>
        <OutlinedInput
          id="outlined-adornment-password"
          placeholder="Password"
          label="Password"
          required
          type={showPassword ? "text" : "password"}
          onChange={(e) => setPassword(e.target.value)}
          endAdornment={
            <InputAdornment position="end">
              <IconButton
                aria-label="toggle password visibility"
                onClick={handleClickShowPassword}
                onMouseDown={handleMouseDownPassword}
                edge="end"
              >
                {showPassword ? <VisibilityOff /> : <Visibility />}
              </IconButton>
            </InputAdornment>
          }
        />
      </FormControl>
      <Button variant="contained" type="submit">
        Login
      </Button>
      <Button component={Link} to="/reset">
        Forgot Password
      </Button>

      <Button onClick={login}>
        <img src={Google} className="icon-sm" />
      </Button>

      {props.children}
    </Stack>
  );
}
